import React, { Component } from "react";
import { connect } from "react-redux";
import { Route, withRouter } from "react-router-dom";

import Landing from "@landing";
import PrevisitApp from "@previsit/components/App";
import PretravelApp from "@pretravel/components/App";
import WorkerhomeApp from "@workerhome/components/App";

import { toggleBackgroundScroll } from "@common/utilities";
import { resetApps } from "@store/actions";

class AppRoutes extends Component {
  componentWillReceiveProps(nextProps) {
    if (this.props.location !== nextProps.location) {
      // Reset all apps and reset scrolling
      this.props.resetApps();
      toggleBackgroundScroll(false);
    }
  }

  render() {
    return (
      <div>
        <Route exact path="/" render={Landing} />
        <Route path="/pretravel" component={PretravelApp} />
        <Route path="/previsit" component={PrevisitApp} />
        <Route path="/homecommunity" component={WorkerhomeApp} />
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    resetApps: () => dispatch(resetApps())
  };
};

export default withRouter(connect(null, mapDispatchToProps)(AppRoutes));



// WEBPACK FOOTER //
// ./src/common/AppRoutes.jsx